<template>
  <div>
    <!--上左右结构框架-->
    <Headbar></Headbar>
    <div class="iframebox">
      <div class="imleft" v-if="sidebarshow">
        <div>
          <div class="myinfo">
            <div class="avatar"><img src="@/assets/avatar_user.jpg"></div>
            <div class="infodata">
              <div class="usercompany">{{greet}}~{{uscompany}}</div>
              <div class="latelylog">上次登录时间：<p>{{$store.state.lastime}}</p></div>
            </div>
          </div>
          <div class="sidemenu" :class="sidename=='a'?'dow':'up'">
            <h4  @click="navlick('a')"><i class="iconfont icon-pingtaishouquan"></i>订单发布审核</h4>
            <ul class="itemnavlist">
              <router-link tag='li' @click.native="buffer('waitconfirm')"  to="/orderexception/waitconfirm" :class="memorystick=='businessauth'?'on':''">待审核订单（{{this.orderData.examine}}）</router-link>
              <!-- <li :class="branch?'on':'off'" ><div class="iconfont icon-jiantou12" @click="subbranch()">打款认证</div>
                <ul>
                  <router-link tag='li' to="/bankacceptance/payauth" :class="memorystick=='payauth'?'onon':''" @click.native="buffer('payauth')" >待打款</router-link>
                  <router-link tag='li' to="/bankacceptance/payauthentication" :class="memorystick=='payauthentication'?'onon':''" @click.native="buffer('payauthentication')" >认证中</router-link>
                </ul>
              </li> -->
            </ul>
          </div>
          <!-- <div class="sidemenu"  :class="sidename=='b'?'dow':'up'">
            <h4 @click="navlick('b')"><i class="iconfont icon-gerendangan"></i>数据更新</h4>
            <ul class="itemnavlist">
              <router-link tag='li' to="/bankacceptance/discountdata" :class="memorystick=='discountdata'?'onon':''" @click.native="buffer('discountdata')" >贴现数据</router-link>
              <router-link tag="li" to="/bankacceptance/interestrate" :class="memorystick=='interestrate'?'onon':''" @click.native="buffer('interestrate')" >贴现利率</router-link>
            </ul>
          </div> -->
          <div class="sidemenu"  :class="sidename=='b'?'dow':'up'">
            <h4 @click="navlick('b')"><i class="iconfont icon-31paixingbang"></i>异常订单处理</h4>
            <ul class="itemnavlist">
              <!-- <router-link tag='li' to="/bankacceptance/discountdata" :class="memorystick=='discountdata'?'onon':''" @click.native="buffer('discountdata')" >背书超时订单</router-link> -->
              <!-- <router-link tag='li'>背书超时订单</router-link> -->
              <router-link tag="li" to="/orderexception/firstovertime" :class="memorystick=='firstovertime'?'on':''" @click.native="buffer('firstovertime')" >首次超时({{this.orderData.firsttimeout}})</router-link>
              <router-link tag='li' to="/orderexception/secondovertime" :class="memorystick=='secondovertime'?'on':''" @click.native="buffer('secondovertime')" >二次超时({{this.orderData.twotimeout}})</router-link>
              <router-link tag="li" to="/orderexception/urgedsign" :class="memorystick=='urgedsign'?'on':''" @click.native="buffer('urgedsign')" >催促签收订单({{this.orderData.urge}})</router-link>
              <router-link tag='li' to="/orderexception/unreceivedbill" :class="memorystick=='unreceivedbill'?'on':''" @click.native="buffer('unreceivedbill')" >未收到票据({{this.orderData.nobill}})</router-link>
              <router-link tag="li" to="/orderexception/refusedsign" :class="memorystick=='refusedsign'?'on':''" @click.native="buffer('refusedsign')" >拒绝签收订单({{this.orderData.refuse}})</router-link>
            </ul>
          </div>
          <!-- <div class="sidemenu"  :class="sidename=='c'?'dow':'up'">
            <h4  @click="navlick('c')"><i class="iconfont icon-31paixingbang"></i>异常订单处理</h4>
            <ul class="itemnavlist">
              <li>用户注册</li>
              <li>贴现金额</li>
            </ul>
          </div> -->

          <!-- <div class="sidemenu"  :class="sidename=='d'?'onno':''">
            <h4 @click="navlick('d')"><i class="iconfont icon-iconfinderbank"></i>路由设置</h4>
          </div>
          <div class="sidemenu"  :class="sidename=='e'?'onno':''">
            <h4  @click="navlick('e')"><i class=" ayy iconfont icon-web-icon-ad"></i>广告设置</h4>
          </div> -->
        </div>
      </div>
      <div class="imright">
            <!-- <span class="toright helpcapsule" v-if="sidebarshow" @click="sidebaroperation()"><span class="iconfont icon-jiantou23"></span>向左收起</span>
            <span class="toleft helpcapsule" v-else  @click="sidebaroperation()"><span class="iconfont icon-jiantou24"></span>向右打开</span> -->
        <router-view :key="refdata" v-if="isRouterAlive"/>
      </div>
    </div>
  </div>
</template>
<script>
//calc
import Headbar from '@/components/headbar'
export default {
  components: {
    Headbar
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      greet:'',
      uscompany:'',
      sidename:'',
      branch:false,
      memorystick:"businessauth",
      sidebarshow:true,
      refdata:0,
      isRouterAlive:true,
      orderData: [],
    }
  },
  mounted:function() {
    this.handleAjax()
    this.sidename = this.$route.query.sideNameId
     this.usid=this.$store.state.userid
    this.uscompany=this.$store.state.user
    var d= new Date();
    if(d.getHours()<5){
      this.greet="凌晨了，注意休息"
    }
    else if(d.getHours()>=5&&d.getHours()<11){
      this.greet="早上好"
    }
    else if(d.getHours()>=11&&d.getHours()<13){
      this.greet="中午好"
    }
    else if(d.getHours()>=13&&d.getHours()<18){
      this.greet="下午好"
    }
    else if(d.getHours()>=18&&d.getHours()<24){
      this.greet="晚上好"
    }
  },
  methods: {
    handleAjax(){
            this.loading=true
            let detailId = this.$route.query.oId
            this.ajax.post('/bill/menustatistic',{bizContent:{}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            let add = result.data.data
                            // console.log(add, '222')
                            // 这个请求页的部分不是所有的数据请求都需要的
                            // add.map((item,index)=>{
                            //     add[index].xh=index+1
                            // })
                            this.orderData=add
                            this.total=result.data.total
                            if(this.radio2=='0'){
                                if(this.tableData.length==0){
                                    this.showCon=false
                                    //下面是修改后的代码，为了让表格显示出来
                                    // this.showCon=true
                                }else{
                                    this.showCon=true
                                }
                            }
                            this.loading=false
                        }else{
                            }
                        }
                )
        },
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    },
    sidebaroperation(){
      this.sidebarshow=!this.sidebarshow
    },
     buffer(val){
       this.memorystick=val
     },
     subbranch(){
       this.branch=!this.branch
     },
     refresh(val){
       this.refdata=new Date().getTime()
       console.log(this.refdata)
     },
     navlick(val){
       if(this.sidename==val&&val!='d'&&val!='e'){
         this.sidename=''
       }
       else{
         this.sidename=val
       }
       if(val=='d'){
         this.$router.push({name:'BankManagement'})
       }
       if(val=='e'){
         this.$router.push('/bankacceptance/advlist')
       }
     }
  }
}
</script>
<style>
body{background-color: #F5F8FC;}
.iframebox{
  padding-top: 90px;
  width:100%;
  height:calc(100% - 90px);
  height:calc( 100vh - 90px);
  display: flex; 
}
.imleft{
  flex: none; 
  width: 200px; 
  overflow-y: auto; 
  display: block;
  background: #4C98E6;
}
.imright{
  flex: auto; 
  display: flex; 
  flex-direction: column; 
  overflow-y: auto; 
  padding:30px 25px 0 25px;
  background: #F5F8FC;
  position: relative;
}
.itemnavlist>li{
  width:100%;
  color:#fff;
  min-height:45px;
  line-height:45px;
  font-size: 16px;
  cursor: pointer;
  text-indent: 60px;
}
.itemnavlist>li::before{
  font-size: 22px; 
  margin:15px;
}
.itemnavlist>li.current{
  background-color:#3A84EC;
  cursor: default;
}
.myinfo{ 
  margin-top: 32px;
  display: table;
  width: 100%;
  clear: both;
  margin-bottom:35px
}
.avatar{
  width:90px;
  height:90px;
  margin:36px auto;
}
.infodata{
  float: left;
}
.infodata{ 
  text-align: center;
  width:100%;
}
.avatar img{
  border-radius: 100%;
  overflow: hidden;
  width:90px;
  height:90px;
}
.usercompany{
  font-size:14px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:20px;
}
.latelylog{
  font-size:12px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:17px;
  margin-top:13px;
}
.latelylog p{
  width: 94%;
}
.lineborder{
  width:200px;
  height:1px;
  opacity:0.2965;
  background-color: #2F77C0; 
}
.sidemenu{
  width:100%;
}
.sidemenu.up{
  height:59px;
  overflow: hidden;
}
.sidemenu h4{
  width:100%;
  height:58px;
  line-height:58px;
  color: #fff;
  text-indent: 60px;
  position: relative;
  cursor: pointer;
}
.sidemenu.dow{
  height:auto;
  display: table;
  overflow: unset;
  background: rgb(75, 159, 243);
  color:#ffffff;
}
.sidemenu.dow h4{
  background-color:#3A84EC;
}
.sidemenu h4::before{
  position: absolute;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  right: 10px;
}
.sidemenu.up h4::before{
  font-size: 14px;
  content: "\e601";
}
.sidemenu.dow h4::before{
  font-size: 14px;
  content: "\e602";
}
.sidemenu h4 i{
  position: absolute;
  font-size: 22px;
  left:-30px;
  top:1px;
}
.itemnavlist li:hover{
  background-color: rgba(47, 120, 192, 0.3);
}
.itemnavlist>li>ul{
  width:100%;
  height:90px;
}
.itemnavlist>li>ul>li{
  height:45px;
  line-height:45px;
  font-size: 14px;
}
.itemnavlist > li > div{
  position:relative;
  width:200px;
  clear: both;
  height:45px;
  display: block;
}
.itemnavlist > li > div:before {
  position: absolute;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  right: 10px;
  top:2px;
  font-size: 22px;
}
.itemnavlist > li.on > div:before {
  content: "\e725";
}
.itemnavlist > li.off > div:before {
  content: "\e726";
}
.itemnavlist > li.off{
  height:45px;
  line-height:45px;
  overflow: hidden;
}
.itemnavlist > li.on{
  height: auto;
  overflow:visible;
  display: table;
  background-color: #4293E4;
}
.on>div{
  opacity: 0.3;
}
.itemnavlist li.nono {
    background-color: rgba(47, 120, 192, 0.3);
}
.icon-iconfinderbank::before{
  font-size: 18px;
  text-align: center;
}
.onno{
  background: #2F77C0;
  opacity: 0.3;
}
.dow h4{
  opacity: 0.3;
}
.helpcapsule{
width:100px;
height:22px;
line-height: 22px;
border-top-right-radius:22px;
border-bottom-right-radius:22px;
display: block;
border:1px solid #ccc;
position: absolute;
left:0;
top:2px;
background: #fff;
cursor: pointer;
color: #666;
}
.helpcapsule span::before{
  font-size: 28px;
   float: left;
   display: block;
}
.helpcapsule:hover{
  color:#333;
  background: linear-gradient(#efefef, #fff); 
}

.ayy::before {
  content: "\e6b5";
  font-size: 32px;
  margin-left:-4px;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-web-icon-ad:before {
  content: "\e6b5";
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>




// WEBPACK FOOTER //
// src/page/companypage/index.vue